import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getLogin = createAsyncThunk(
  "Auth/getLogin",
  async (resD, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/login`,
          {
            ...resD,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getLogout = createAsyncThunk(
  "Auth/getLogout",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonDT")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getRoles = createAsyncThunk(
  "Admin/getRoles",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/roles`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getPermissions = createAsyncThunk(
  "Admin/getPermissions",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/permissions`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const AuthSlice = createSlice({
  name: "Auth",
  initialState: {
    isAuthLoading: false,
    error: null,
    LoginArr: null,
    RolesArr: null,
    PermissionsArr: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLogin.pending, (state) => {
        state.isAuthLoading = true;
      })
      .addCase(getLogin.fulfilled, (state, action) => {
        state.isAuthLoading = false;
        state.LoginArr = action.payload.data;
      })
      .addCase(getLogin.rejected, (state, action) => {
        state.isAuthLoading = false;
      })
      .addCase(getLogout.pending, (state) => {
        state.isAuthLoading = true;
      })
      .addCase(getLogout.fulfilled, (state, action) => {
        state.isAuthLoading = false;
      })
      .addCase(getLogout.rejected, (state, action) => {
        state.isAuthLoading = false;
      })
      .addCase(getRoles.pending, (state) => {
        state.isAuthLoading = true;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.RolesArr = action.payload.data;
        state.isAuthLoading = false;
      })
      .addCase(getRoles.rejected, (state) => {
        state.isAuthLoading = false;
      })

      .addCase(getPermissions.pending, (state) => {
        state.isAuthLoading = true;
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.PermissionsArr = action.payload.data;
        state.isAuthLoading = false;
      })
      .addCase(getPermissions.rejected, (state) => {
        state.isAuthLoading = false;
      });
  },
});

export default AuthSlice.reducer;
